export const COMPANY = {
  name: "JP Energy Solution",
  legal: "JP Energy Solution LTD",
  tagline: "Offshore Marine Electrical Engineering",
  email: "engineering@jpenergysolution.com",
  phone: "+44 20 7946 0321",
  address: "Ocean House, Marine Technology Park, Aberdeen, United Kingdom",
  reg: "Company Reg. No. 09384756 — Registered in England & Wales",
};

export const NAV = [
  { label: "Capabilities", href: "#capabilities" },
  { label: "Services", href: "#services" },
  { label: "Assurance", href: "#assurance" },
  { label: "Contact", href: "#contact" },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "High-Voltage Installations",
    body: "Design, installation and commissioning of HV power systems engineered to withstand the harshest offshore conditions — from platform substations to subsea distribution.",
    img: "https://images.unsplash.com/photo-1563456019560-2b37aa7ad890?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHw0fHxoaWdoJTIwdm9sdGFnZSUyMGVsZWN0cmljYWwlMjBwYW5lbCUyMGluZHVzdHJpYWx8ZW58MHx8fHwxNzg1NzY2MjQ1fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    no: "02",
    title: "Power Distribution",
    body: "Resilient distribution architecture and load management for platforms and vessels, balancing redundancy, efficiency and continuity of critical maritime operations.",
    img: "https://images.pexels.com/photos/3192662/pexels-photo-3192662.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    no: "03",
    title: "Systems Automation",
    body: "Intelligent control, SCADA integration and condition monitoring that turn raw power into precise, observable, remotely-governable offshore systems.",
    img: "https://images.unsplash.com/photo-1598408745613-178751e2ccde?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxtYXJpbmUlMjB2ZXNzZWwlMjBvY2VhbnxlbnwwfHx8fDE3ODU3NjYyNDV8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    no: "04",
    title: "Emergency Diagnostics",
    body: "Rapid-response fault diagnosis and restoration under SLA, keeping crews safe and assets online when every minute of downtime carries real cost.",
    img: "https://images.unsplash.com/photo-1612812746054-7dfda5dd2e27?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHw0fHxvZmZzaG9yZSUyMHdpbmQlMjBmYXJtJTIwb2NlYW58ZW58MHx8fHwxNzg1NzY2MjQ1fDA&ixlib=rb-4.1.0&q=85",
  },
];

export const SERVICES = [
  {
    tag: "Renewables",
    title: "Offshore Wind Farms",
    body: "Array cabling, turbine electrical integration and substation maintenance for utility-scale offshore wind.",
  },
  {
    tag: "Oil & Gas",
    title: "Offshore Platforms",
    body: "High-voltage engineering and automation for fixed and floating production platforms in the North Sea and beyond.",
  },
  {
    tag: "Fleet",
    title: "Marine Vessels",
    body: "Onboard electrical refits, propulsion power systems and class-compliant diagnostics for working fleets.",
  },
];

export const STATS = [
  { value: "24/7", label: "Emergency response under SLA" },
  { value: "3", label: "Continents served worldwide" },
  { value: "99.9%", label: "Assured system uptime" },
  { value: "IMO", label: "Maritime safety standards" },
];

export const REGIONS = ["Europe", "Asia", "Americas", "Global / International"];
export const SERVICE_OPTIONS = [
  "High-Voltage Installations",
  "Power Distribution",
  "Systems Automation",
  "Emergency Diagnostics",
  "Long-term SLA / Consulting",
];
